import { FACETED_SEARCH_QUERY } from '../constants';

export const historyMiddleware = (store) => (next) => (action) => {
    const { type, payload } = action;
    switch (type) {
        case FACETED_SEARCH_QUERY:
            let { query, replace } = payload;
            const url =
                window.location.href.replace(window.location.search, '') +
                `${query ? '?' : ''}${query}`;
            // A query the visitor did not ask for replaces the current entry instead of adding one,
            // so Back still leaves the page. Used by the Apex grade tabs, which select their first
            // tab on load; everything else keeps pushing.
            if (replace) {
                window.history.replaceState('search', 'Search Page', url);
            } else {
                window.history.pushState('search', 'Search Page', url);
            }
            break;
    }
    next(action);
};
